import React, { useEffect, useState } from 'react';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import cx from 'classnames';
import classNames from 'classnames';
import s from './DateInput.module.css';
import { useTranslation } from 'react-i18next';

interface DateInputProps {
    date?: string;
    parameterName: string;
    callback?: (date?: string) => void;
    options: any;
    title?: string;
    isRequired?: boolean;
    newCallback?: (date: string) => void;
    isDisabled?: boolean;
    newCallbackNotSingle?: (dates: { start: string; end: string }) => void;
    placeholder?: string;
    newCallbackNotSingleCancel?: () => void;
    classes?: string;
}

export function DateInput({
    date,
    parameterName,
    callback = null,
    options,
    title = null,
    isRequired = false,
    newCallback = null,
    isDisabled = false,
    newCallbackNotSingle = null,
    placeholder = null,
    newCallbackNotSingleCancel = null,
    classes,
}: DateInputProps) {
    const { t } = useTranslation();
    const [inputValue, setInputValue] = useState<string>(date);

    useEffect(() => {
        console.log(inputValue);
    }, []);

    const locale = {
        format: 'DD.MM.YYYY',
        firstDay: 1,
        daysOfWeek: [
            t('DateInput.locale.format.daysOfWeek.sunday'),
            t('DateInput.locale.format.daysOfWeek.monday'),
            t('DateInput.locale.format.daysOfWeek.tuesday'),
            t('DateInput.locale.format.daysOfWeek.wednesday'),
            t('DateInput.locale.format.daysOfWeek.thursday'),
            t('DateInput.locale.format.daysOfWeek.friday'),
            t('DateInput.locale.format.daysOfWeek.saturday'),
        ],
        monthNames: [
            t('DateInput.locale.format.monthNames.january'),
            t('DateInput.locale.format.monthNames.february'),
            t('DateInput.locale.format.monthNames.march'),
            t('DateInput.locale.format.monthNames.april'),
            t('DateInput.locale.format.monthNames.may'),
            t('DateInput.locale.format.monthNames.june'),
            t('DateInput.locale.format.monthNames.july'),
            t('DateInput.locale.format.monthNames.august'),
            t('DateInput.locale.format.monthNames.september'),
            t('DateInput.locale.format.monthNames.october'),
            t('DateInput.locale.format.monthNames.november'),
            t('DateInput.locale.format.monthNames.december'),
        ],
        cancelLabel: t('DateInput.locale.format.cancelLabel'),
        applyLabel: t('DateInput.locale.format.applyLabel'),
    };

    const initialSettings = { ...options, locale };

    const inputProps = {
        defaultValue: options.options || '',
    };

    const handleCancel = (event: any, picker: any) => {
        if (date === '') {
            return;
        }
        picker.element.val('');
        if (callback) {
            callback('');
        }
        if (newCallbackNotSingleCancel) {
            newCallbackNotSingleCancel();
        }
    };

    const handleApply = (event: any, picker: any) => {
        const formattedDate = picker.startDate.format('DD.MM.YYYY');
        picker.element.val(formattedDate);
        setInputValue(formattedDate);
        if (callback) {
            callback(picker.startDate.format());
        }
        if (newCallback) {
            newCallback(picker.startDate.format('YYYY-MM-DD'));
        }
        if (newCallbackNotSingle) {
            picker.element.val(
                `${picker.startDate.format('DD.MM.YYYY')} - ${picker.endDate.format('DD.MM.YYYY')}`
            );
            newCallbackNotSingle({
                start: picker.startDate.format('DD.MM.YYYY'),
                end: picker.endDate.format('DD.MM.YYYY'),
            });
        }
    };

    useEffect(() => {
        setInputValue(date);
    }, [date]);

    return (
        <div className={classNames(s.wrapperInput, [classes], { [s.disabled]: isDisabled })}>
            {title && (
                <label className={classNames(s.modalLabelSelect)}>
                    {title}
                    {isRequired && <span>*</span>}
                </label>
            )}
            <div className={s.calendar}>
                <DateRangePicker
                    initialSettings={initialSettings}
                    onApply={handleApply}
                    onCancel={handleCancel}
                    {...inputProps}
                >
                    <input
                        value={inputValue}
                        placeholder={placeholder || ''}
                        disabled={isDisabled}
                        data-id={parameterName}
                        className={cx(s.input, s.calendarInput)}
                        type="text"
                    />
                </DateRangePicker>
                <div className={classNames(s.calendarIcon, { [s.disabled]: isDisabled })} />
            </div>
        </div>
    );
}
